import { render, staticRenderFns } from "./ysv1.vue?vue&type=template&id=6f047dbc&scoped=true"
import script from "./ysv1.vue?vue&type=script&lang=js"
export * from "./ysv1.vue?vue&type=script&lang=js"
import style0 from "./ysv1.vue?vue&type=style&index=0&id=6f047dbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f047dbc",
  null
  
)

export default component.exports